module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message",
    class: _vm.classes
  }, [_c('p', {
    staticClass: "message__title"
  }, [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('p', {
    staticClass: "message__content"
  }, [_vm._v(_vm._s(_vm.message.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae83dc78!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/Message.vue
// module id = 756
// module chunks = 1